import { apiFetch } from './client';

export const feedbackApi = {
  send: (text: string) =>
    apiFetch<{ ok: boolean; id: string }>('/api/feedback', {
      method: 'POST',
      body: JSON.stringify({ text }),
    }),

  // Отправка всего диалога в поддержку (кнопка в меню чата).
  // consent обязателен: сервер отклонит запрос без явного согласия.
  sendChatReport: (conversationId: string, comment?: string) =>
    apiFetch<{ ok: boolean; id: string; messageCount: number }>('/api/feedback/chat-report', {
      method: 'POST',
      body: JSON.stringify({ conversationId, comment, consent: true }),
    }),

  // Сброс конструктора автоматизаций: фиксируем шаг, на котором человек ушёл,
  // и необязательный комментарий «что не понравилось».
  wizardDrop: (payload: {
    step: string;
    prompt?: string;
    comment?: string;
    questionsAnswered?: number;
    questionsTotal?: number;
    lastError?: string;
  }) =>
    apiFetch<{ ok: boolean; id: string }>('/api/feedback/wizard-drop', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
